import axios from "axios";

export const fetchImportTaskList = async (data: any) => {
    const body = { file: data.file, companyId: data.companyId };
    const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
    return await axios.post(
        `${baseTaskUrl}/TaskTemplate/import`,
        body,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
        }
    );
};
